import 'rc-slider/assets/index.css';
import React, { Component } from 'react';
import Slider from 'rc-slider';
import NumberField from "./NumberInput";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import Tooltip from 'react-tooltip';

const Handle = Slider.Handle;
const contactUrl = window.location.origin + '/kontakt';

const handle = (props) => {
    const { value, dragging, index, ...restProps } = props;
    return (
        <Handle value={value} {...restProps}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 102">
                <g style={{ opacity: 0.9 }}>
                    <polygon style={{ fill: '#000' }} points="58.841 0 0 102 117.682 102 58.841 0" />
                </g>
                <g style={{ opacity: 0.8 }}>
                    <polygon style={{ fill: '#000' }} points="58.841 102 58.841 0 128 0 58.841 102" />
                </g>
            </svg>
        </Handle>
    );
};

class CalcControl extends Component {
    render() {
        return (
            <div className="creditCalcControl">
                <label className="creditCalcControlLabel">{this.props.label}</label>

                <div className="creditCalcControlInner">
                    <Slider
                        className="creditCalcControlSlider"
                        handle={handle}
                        min={this.props.min}
                        max={this.props.max}
                        step={this.props.step}
                        value={this.props.value}
                        onChange={this.props.onSliderChange.bind(this, this.props.name)}
                        onAfterChange={this.props.onAfterChange}
                    />
                    <NumberField
                        className="creditCalcControlInput"
                        value={this.props.value}
                        name={this.props.name}
                        change={this.props.onInputChange}
                        min={this.props.min}
                        max={this.props.max}
                        currency={this.props.currency | false}
                        decimals={this.props.decimals | 0}
                    />
                </div>
                <div className=''>
                    {(this.props.name === "objectCosts" && this.props.value === 1000000) && (
                        <>
                            <FontAwesomeIcon icon={faInfoCircle} data-tip={'Sie benötigen eine höhere Summe? Hier anfragen'} />
                             <span className='m-left-10 creditCalcTooltip'>Sie benötigen eine höhere Summe? <a href={contactUrl}>Hier anfragen</a></span>
                            {/* <Tooltip /> */}
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default CalcControl;